import React, { useEffect, useState } from 'react';
import DateInput from '../components/DateInput';
import api from '../api/axios';
import { format } from 'date-fns';

export default function AuditTrail() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [filters, setFilters] = useState({ user_id:'', order_no:'', date_from:'', date_to:'' });

  const load = () => {
    setLoading(true);
    const params = Object.fromEntries(Object.entries(filters).filter(([,v])=>v));
    api.get('/audit', { params }).then(r => { setLogs(r.data); setLoading(false); });
  };

  useEffect(() => {
    load();
    api.get('/users').then(r => setUsers(r.data));
  }, []);

  return (
    <div>
      <div className="page-header"><h2>Audit Trail</h2><p>Complete read-only history of all system changes</p></div>

      <div className="filter-bar">
        <div className="form-group"><label>User</label>
          <select className="form-control" value={filters.user_id} onChange={e=>setFilters({...filters,user_id:e.target.value})}>
            <option value="">All Users</option>{users.map(u=><option key={u.id} value={u.id}>{u.full_name}</option>)}
          </select>
        </div>
        <div className="form-group"><label>Order No</label><input className="form-control" value={filters.order_no} onChange={e=>setFilters({...filters,order_no:e.target.value})} /></div>
        <div className="form-group"><label>From</label><DateInput className="form-control" value={filters.date_from} onChange={e=>setFilters({...filters,date_from:e.target.value})} /></div>
        <div className="form-group"><label>To</label><DateInput className="form-control" value={filters.date_to} onChange={e=>setFilters({...filters,date_to:e.target.value})} /></div>
        <button className="btn btn-primary btn-sm" onClick={load}>Apply</button>
        <button className="btn btn-secondary btn-sm" onClick={()=>setFilters({user_id:'',order_no:'',date_from:'',date_to:''})}>Clear</button>
      </div>

      <div className="card" style={{padding:0}}>
        {loading ? <div className="loading">Loading...</div> : logs.length === 0 ? <div className="empty-state">No audit records found</div> :
          <div className="table-wrap">
            <table>
              <thead><tr><th>Date/Time</th><th>User</th><th>Order</th><th>Table</th><th>Action</th><th>Field</th><th>Old Value</th><th>New Value</th></tr></thead>
              <tbody>
                {logs.map(a => (
                  <tr key={a.id}>
                    <td className="text-muted" style={{whiteSpace:'nowrap'}}>{format(new Date(a.created_at),'dd/MM/yyyy HH:mm:ss')}</td>
                    <td>{a.full_name}</td>
                    <td>{a.order_no||'—'}</td>
                    <td><span className="badge badge-gray">{a.table_name}</span></td>
                    <td><span className="badge badge-blue">{a.action_type}</span></td>
                    <td className="text-muted">{a.field_name||'—'}</td>
                    <td className="text-danger" style={{maxWidth:'140px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{a.old_value||'—'}</td>
                    <td className="text-success" style={{maxWidth:'140px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{a.new_value||'—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        }
      </div>
    </div>
  );
}
